import styled from 'styled-components';

export const MessageContainer = styled.p`
  img {
    max-width: 100%;
    height: auto;
    display: block;
  }
`;
